import { MainIndexDB } from "../mainIndexDB";
import storageKey from "../storageKey";

const Style = {
  Default: [
    "color: inherit",
    "background-color: inherit",
    "padding: inherit",
    "border-radius: inherit",
  ],
  Base: ["color: #fff", "background-color: #444", "padding: 2px 4px", "border-radius: 2px"],
  BaseInverted: ["color: #444", "background-color: #fff", "padding: 2px 4px", "border-radius: 2px"],
  Error: ["background-color: red"],
  ColorError: ["color: red"],
  Info: ["background-color: blue"],
  ColorInfo: ["color: blue"],
  Success: ["background-color: green"],
  ColorSuccess: ["color: green"],
  Warning: ["background-color: orange"],
  ColorWarning: ["color: orange"],
  Gray: ["background-color: dimgray"],
  ColorGray: ["color: dimgray"],
  Pink: ["background-color: deeppink"],
  ColorPink: ["color: deeppink"],
  Purple: ["background-color: darkviolet"],
  ColorPurple: ["color: darkviolet"],
};

export const CLG = {
  Error: (title?: string) => {
    return [
      "%c[ERROR]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorError.join(";"),
      Style.Default,
    ];
  },
  Info: (title?: string) => {
    return [
      "%c[INFO]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorInfo.join(";"),
      Style.Default,
    ];
  },
  Warn: (title?: string) => {
    return [
      "%c[WARN]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorWarning.join(";"),
      Style.Default,
    ];
  },
  Success: (title?: string) => {
    return [
      "%c[SUCCESS]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorSuccess.join(";"),
      Style.Default,
    ];
  },
  Gray: (title?: string) => {
    return [
      "%c[GRAY WARN]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorGray.join(";"),
      Style.Default,
    ];
  },
  Pink: (title?: string) => {
    return [
      "%c[PINK WARN]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorPink.join(";"),
      Style.Default,
    ];
  },
  Purple: (title?: string) => {
    return [
      "%c[PURPLE WARN]" + (title ? " " + title : "") + "%c ",
      Style.BaseInverted.join(";") + ";" + Style.ColorPurple.join(";"),
      Style.Default,
    ];
  },
};

const ShowLog = window.localStorage.getItem(storageKey.SHOW_LOG) ? true : false;

class Dev {
  private title: string | undefined;
  private args: any[] = [];

  constructor(title: string, ...allArgs: any[]) {
    if (arguments[0]) this.title = arguments[0];

    let argsToPush = [];
    for (let index = 1; index < arguments.length; index++) {
      argsToPush.push(arguments[index]);
    }

    this.args = argsToPush;
  }

  private _mountReturn(headerTitle: string, style: string[]) {
    let arrayReturn = [
      `%c[${headerTitle}]` + (this?.title ? " " + this?.title : "") + "%c ",
      Style.Base.join(";") + ";" + style.join(";"),
      Style.Default,
    ];

    for (let index = 0; index < this.args.length; index++) {
      const objectType = typeof this.args[index];

      if (objectType === "object") {
        arrayReturn.push("\n");
        if (index === 0) {
          arrayReturn.push("\n");
        }
      }

      arrayReturn.push(this.args[index]);
      arrayReturn.push("\n");
    }

    return arrayReturn;
  }

  public Error(error?: Error) {
    let logArray = this._mountReturn("ERROR", Style.Error);
    try {
      MainIndexDB.saveDataToStore("app-log", {
        content: {
          title: this.title,
          style: logArray[1],
          args: this.args,
          createdAtTimestamp: new Date().getTime(),
        },
      });
    } catch (error) {
      console.log("ERRO AO SALVAR LOG");
    }
    return ShowLog ? logArray : [];
  }

  public Success() {
    let logArray = this._mountReturn("SUCCESS", Style.Success);
    return ShowLog ? logArray : [];
  }

  public Warn() {
    let logArray = this._mountReturn("WARN", Style.Warning);
    try {
      MainIndexDB.saveDataToStore("app-log", {
        content: {
          title: this.title,
          style: logArray[1],
          args: this.args,
          createdAtTimestamp: new Date().getTime(),
        },
      });
    } catch (error) {
      console.log("ERRO AO SALVAR LOG");
    }
    return ShowLog ? logArray : [];
  }

  public Info() {
    let logArray = this._mountReturn("INFO", Style.Info);
    return ShowLog ? logArray : [];
  }

  public Log() {
    let logArray = this._mountReturn("LOG", Style.Gray);
    return ShowLog ? logArray : [];
  }

  public Pink() {
    let logArray = this._mountReturn("PINK LOG", Style.Pink);
    return ShowLog ? logArray : [];
  }

  public Purple() {
    let logArray = this._mountReturn("PURPLE LOG", Style.Purple);
    return ShowLog ? logArray : [];
  }

  public Color(color: "Error" | "Info" | "Success" | "Warning" | "Gray" | "Pink" | "Purple") {
    let logArray = this._mountReturn("CUSTOM LOG", Style[color]);
    return ShowLog ? logArray : [];
  }

  public Stack() {
    const stackTrace = Error().stack;
    console.log(stackTrace);

    let logArray = this._mountReturn("STACK", Style.Info);
    return ShowLog ? logArray : [];
  }
}

export { Dev };
